var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7702 4.82567C7.21026 3.03809 6.11789 1.23223 4.33031 0.792162C2.54273 0.352098 0.73687 1.44447 0.296806 3.23205C-0.143258 5.01963 0.949118 6.82549 2.7367 7.26556C4.52428 7.70562 6.33014 6.61324 6.7702 4.82567Z",
    fill: "#C3A0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDot);
export default __webpack_public_path__ + "static/media/list-dot.f35c3834a7fb484649681d0194b42eae.svg";
export { ForwardRef as ReactComponent };